import { useMemo, useState } from "react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import MediaGrid from "../components/MediaGrid";
import { social } from "../data/site";
import gallery from "../data/gallery";

export default function Gallery() {
  const [active, setActive] = useState("all");

  const tabs = useMemo(
    () => [{ id: "all", title: "All" }, ...gallery.map((t) => ({ id: t.id, title: t.title }))],
    []
  );

  const posts = useMemo(() => {
    if (active === "all") return gallery.flatMap((t) => t.posts);
    return gallery.find((t) => t.id === active)?.posts || [];
  }, [active]);

  const activeTheme = gallery.find((t) => t.id === active);

  return (
    <>
      <PageHero
        eyebrow="Gallery"
        title="A gallery of brilliance"
        subtitle="Explore our photographed pieces and reels — diamond and premium CZ jewellery from Culture Diamond Jewels."
        image="/assets/cd/prod-neck-pear.jpg"
      />

      <section className="py-20">
        <div className="container-luxe">
          {/* Filter tabs */}
          <div className="mb-12 flex flex-wrap items-center justify-center gap-3">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActive(tab.id)}
                className={`border px-5 py-2.5 font-sans text-xs uppercase tracking-[0.2em] transition-all duration-300 ${
                  active === tab.id
                    ? "border-gold bg-gold text-white"
                    : "border-charcoal/15 text-charcoal/70 hover:border-gold hover:text-gold-dark"
                }`}
              >
                {tab.title}
              </button>
            ))}
          </div>

          {activeTheme && (
            <Reveal className="mb-10 text-center">
              <p className="font-serif text-2xl font-light text-charcoal/90">
                {activeTheme.title}
              </p>
              <p className="mt-1 font-sans text-sm font-light text-charcoal/50">
                {activeTheme.description}
              </p>
            </Reveal>
          )}

          <MediaGrid key={active} items={posts} />

          <div className="mt-16 text-center">
            <a
              href={social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold"
            >
              Follow {social.instagramHandle}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
